import {extend} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';

const translationPrefix = 'kilowhat-cimaise.forum.nav.';

export default function () {
    extend(IndexPage.prototype, 'navItems', function (items) {
        if (app.forum.cimaiseCanView()) {
            items.add('cimaise-albums', LinkButton.component({
                icon: 'far fa-images',
                href: app.route('cimaiseAlbumList'),
            }, app.translator.trans(translationPrefix + 'albums')));

            items.add('cimaise-pictures', LinkButton.component({
                icon: 'far fa-images',
                href: app.route('cimaisePictureList'),
            }, app.translator.trans(translationPrefix + 'pictures')));
        }
    });

    extend(UserPage.prototype, 'navItems', function (items) {
        if (app.forum.cimaiseCanView()) {
            items.add('cimaise-pictures', LinkButton.component({
                icon: 'far fa-images',
                href: app.route('cimaiseUserPictures', {
                    username: this.user!.username(),
                }),
            }, [
                app.translator.trans(translationPrefix + 'user-pictures'),
                ' ',
                m('span.Button-badge', this.user!.cimaisePictureCount()),
            ]));
        }
    })
}
